import { Box, Container, Grid, Heading, Text } from 'theme-ui';
import { Link } from 'components/ui/links';

export default function Footer() {
  const footerHeadingStyles = {
    gridColumn: 'span 12',
    mt: [64, 100],
  };
  const headingStyles = {
    color: 'brandBlue',
    mb: [16, 24],
    mt: [24, 48],
  };
  const linkStyles = {
    mb: 16,
  };
  const groupStyles = {};

  return (
    <Container as="footer" sx={{ mb: [16, 100] }}>
      <Box variant="layout.gridContent">
        <Heading as="h3" variant="displayMedium" sx={footerHeadingStyles}>
          More Resume Examples
        </Heading>
      </Box>
      <Grid
        variant="fullPadded"
        as="section"
        sx={{
          gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
        }}
      >
        <Box as="nav" sx={groupStyles}>
          <Heading as="h2" variant="titleEmphasis" sx={headingStyles}>
            Engineering Resume Examples
          </Heading>
          <Box as="ul" variant="styles.ul.unstyled">
            <li>
              <Link href="/examples/ios-developer" sx={linkStyles}>
                <Text variant="titleEmphasis">iOS Developer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/software-engineer" sx={linkStyles}>
                <Text variant="titleEmphasis">Software Engineer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/data-scientist" sx={linkStyles}>
                <Text variant="titleEmphasis">Data Scientist</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/engineering-manager" sx={linkStyles}>
                <Text variant="titleEmphasis">Engineering Manager</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/web-developer" sx={linkStyles}>
                <Text variant="titleEmphasis">Web Developer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/front-end-developer" sx={linkStyles}>
                <Text variant="titleEmphasis">Front End Developer</Text>
              </Link>
            </li>
          </Box>
        </Box>
        <Box as="nav" sx={groupStyles}>
          <Heading as="h2" variant="titleEmphasis" sx={headingStyles}>
            Design Resume Examples
          </Heading>
          <Box as="ul" variant="styles.ul.unstyled">
            <li>
              <Link href="/examples/ux-designer" sx={linkStyles}>
                <Text variant="titleEmphasis">UX Designer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/graphic-designer" sx={linkStyles}>
                <Text variant="titleEmphasis">Graphic Designer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/web-designer" sx={linkStyles}>
                <Text variant="titleEmphasis">Web Designer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/product-designer" sx={linkStyles}>
                <Text variant="titleEmphasis">Product Designer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/creative-director" sx={linkStyles}>
                <Text variant="titleEmphasis">Creative Director</Text>
              </Link>
            </li>
          </Box>
        </Box>
        <Box as="nav" sx={groupStyles}>
          <Heading as="h2" variant="titleEmphasis" sx={headingStyles}>
            Product Resume Examples
          </Heading>
          <Box as="ul" variant="styles.ul.unstyled">
            <li>
              <Link href="/examples/product-manager" sx={linkStyles}>
                <Text variant="titleEmphasis">Product Manager</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/project-manager" sx={linkStyles}>
                <Text variant="titleEmphasis">Project Manager</Text>
              </Link>
            </li>
          </Box>
        </Box>
        <Box as="nav" sx={groupStyles}>
          <Heading as="h2" variant="titleEmphasis" sx={headingStyles}>
            Marketing Resume Examples
          </Heading>
          <Box as="ul" variant="styles.ul.unstyled">
            <li>
              <Link href="/examples/digital-marketer" sx={linkStyles}>
                <Text variant="titleEmphasis">Digital Marketer</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/marketing-manager" sx={linkStyles}>
                <Text variant="titleEmphasis">Marketing Manager</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/copywriter" sx={linkStyles}>
                <Text variant="titleEmphasis">Copywriter</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/content-strategist" sx={linkStyles}>
                <Text variant="titleEmphasis">Content Strategist</Text>
              </Link>
            </li>
          </Box>
        </Box>
        <Box as="nav" sx={groupStyles}>
          <Heading as="h2" variant="titleEmphasis" sx={headingStyles}>
            Sales Resume Examples
          </Heading>
          <Box as="ul" variant="styles.ul.unstyled">
            <li>
              <Link href="/examples/account-executive" sx={linkStyles}>
                <Text variant="titleEmphasis">Account Executive</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/account-manager" sx={linkStyles}>
                <Text variant="titleEmphasis">Account Manager</Text>
              </Link>
            </li>
            <li>
              <Link href="/examples/sales-manager" sx={linkStyles}>
                <Text variant="titleEmphasis">Sales Manager</Text>
              </Link>
            </li>
          </Box>
        </Box>
      </Grid>
    </Container>
  );
}
